import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-w.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-w.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { ViewApplicationService } from "../../../view-application.service";
import { ViewApplicationLocationWConstants } from "../view-application-location-w/view-application-location-w.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { ViewApplicationDetailsWConstants } from "./view-application-details-w.constants";
import { AppControllerService } from "../../../../../app-controller.service";
import { ViewApplicationProfessionalBodiesWConstants } from "../view-application-professional-bodies-w/view-application-professional-bodies-w.constants";
import { DatePipe } from "@angular/common";
import { AlertType } from "../../../../../shared/models/alert";
import { CompareDatesUtil } from "../../../../../shared/utils/date-field-validator.utils";
import { take, takeUntil } from "rxjs/operators";
let ViewApplicationDetailsWComponent = class ViewApplicationDetailsWComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    routerParamsService;
    viewApplicationService;
    appController;
    datePipe;
    changeDetectorRefs;
    detailsForm;
    saveBtnPlaceholder = ViewApplicationLocationWConstants.SAVE_BUTTON_PLACEHOLDER;
    validationMessages = ViewApplicationDetailsWConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    descriptionFormControlName = ViewApplicationDetailsWConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationDetailsWConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    clientReferenceNumberFormControlName = ViewApplicationDetailsWConstants.CLIENT_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    applicantTelecommunicationLicenseNumberFormControlName = ViewApplicationDetailsWConstants.APPLICANT_TELECOMMUNICATION_LICENCE_NUMBER_FORM_CONTROL_NAME;
    scopeOfWorkFormControlName = ViewApplicationDetailsWConstants.SCOPE_OF_WORK_FORM_CONTROL_NAME;
    estimatedConstructionCostFormControlName = ViewApplicationDetailsWConstants.ESTIMATED_CONSTRUCTION_COST_FORM_CONTROL_NAME;
    applicationFeeFormControlName = ViewApplicationDetailsWConstants.APPLICATION_FEE_FORM_CONTROL_NAME;
    constructionPeriodFormControlName = ViewApplicationDetailsWConstants.CONSTRUCTION_PERIOD_FORM_CONTROL_NAME;
    proposedStartDateFormControlName = ViewApplicationDetailsWConstants.PROPOSED_START_DATE_FORM_CONTROL_NAME;
    proposedEndDateFormControlName = ViewApplicationDetailsWConstants.PROPOSED_END_DATE_FORM_CONTROL_NAME;
    laneClosureIsRequiredFormControlName = ViewApplicationDetailsWConstants.LANE_CLOSURE_IS_REQUIRED_FORM_CONTROL_NAME;
    laneClosureExtentFormControlName = ViewApplicationDetailsWConstants.LANE_CLOSURE_EXTENT_FORM_CONTROL_NAME;
    constructionPeriodUnitsFormControlName = ViewApplicationDetailsWConstants.CONSTRUCTION_PERIOD_UNITS_FORM_CONTROL_NAME;
    servicesFormControlName = ViewApplicationDetailsWConstants.SERVICES_FORM_CONTROL_NAME;
    electricalServicesFormControlName = ViewApplicationDetailsWConstants.ELECTRICAL_SERVICES_FORM_CONTROL_NAME;
    actualStartDateFormControlName = ViewApplicationDetailsWConstants.ACTUAL_START_DATE_FORM_CONTROL_NAME;
    actualEndDateFormControlName = ViewApplicationDetailsWConstants.ACTUAL_END_DATE_FORM_CONTROL_NAME;
    referenceNumberControlName = ViewApplicationDetailsWConstants.REFERENCE_NUMBER_FORM_CONTROL_NAME;
    previousReferenceNumberFormControlName = ViewApplicationDetailsWConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    isResubmissionFormControlName = ViewApplicationDetailsWConstants.IS_RESUBMISSION_FORM_CONTROL_NAME;
    descriptionLabel = ViewApplicationDetailsWConstants.DESCRIPTION_LABEL;
    applicationTypeLabel = ViewApplicationDetailsWConstants.APPLICATION_TYPE_LABEL;
    clientReferenceNumberLabel = ViewApplicationDetailsWConstants.CLIENT_REFERENCE_NUMBER_LABEL;
    applicantTelecommunicationLicenseNumberLabel = ViewApplicationDetailsWConstants.APPLICANT_TELECOMMUNICATION_LICENCE_NUMBER_LABEL;
    scopeOfWorkFormLabel = ViewApplicationDetailsWConstants.SCOPE_OF_WORK_LABEL;
    estimatedConstructionCostLabel = ViewApplicationDetailsWConstants.ESTIMATED_CONSTRUCTION_COST_LABEL;
    applicationFeeLabel = ViewApplicationDetailsWConstants.APPLICATION_FEE_LABEL;
    constructionPeriodLabel = ViewApplicationDetailsWConstants.CONSTRUCTION_PERIOD_LABEL;
    proposedStartDateLabel = ViewApplicationDetailsWConstants.PROPOSED_START_DATE_LABEL;
    proposedEndDateLabel = ViewApplicationDetailsWConstants.PROPOSED_END_DATE_LABEL;
    laneClosureIsRequiredLabel = ViewApplicationDetailsWConstants.LANE_CLOSURE_IS_REQUIRED_LABEL;
    laneClosureExtentLabel = ViewApplicationDetailsWConstants.LANE_CLOSURE_EXTENT_LABEL;
    constructionPeriodUnitsLabel = ViewApplicationDetailsWConstants.CONSTRUCTION_PERIOD_UNITS_LABEL;
    servicesLabel = ViewApplicationDetailsWConstants.SERVICES_LABEL;
    electricalServicesLabel = ViewApplicationDetailsWConstants.ELECTRICAL_SERVICES_LABEL;
    actualStartDateLabel = ViewApplicationDetailsWConstants.ACTUAL_START_DATE_LABEL;
    actualEndDateLabel = ViewApplicationDetailsWConstants.ACTUAL_END_DATE_LABEL;
    referenceNumberLabel = ViewApplicationDetailsWConstants.REFERENCE_NUMBER_LABEL;
    previousReferenceNumberLabel = ViewApplicationDetailsWConstants.PREVIOUS_REFERENCE_NUMBER_LABEL;
    isResubmissionLabel = ViewApplicationDetailsWConstants.IS_RESUBMISSION_LABEL;
    applicationTypes = [];
    zones = [];
    yesNoOptions = [];
    laneClosureExtentOptions = [];
    electricalServicesOptions = [];
    applicationTypeOptions = [];
    servicesOptions = [];
    constructionPeriodUnitsOptions = [
        { code: "Days", value: "Days" },
        { code: "Months", value: "Months" },
        { code: "Weeks", value: "Weeks" },
        { code: "Years", value: "Years" }
    ];
    application;
    getApplicationSaveObservableSubscription;
    getStepMetaObservableSubscription;
    supportResubmissions = false;
    isResubmission = false;
    constructor(aflaModuleStrategyService, route, routerParamsService, viewApplicationService, appController, datePipe, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.viewApplicationService = viewApplicationService;
        this.appController = appController;
        this.datePipe = datePipe;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        this.getMetadata();
        if (this.appController.moduleAllowResubmission) {
            this.supportResubmissions = true;
        }
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    handleRouteChange() {
        // this.getMetadata();
    }
    getApplication() {
        const params = {
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetApplicationCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationProfessionalBodiesWConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onBtnSaveClicked() {
        if (this.detailsForm.valid) {
            const app = {
                isResubmission: this.detailsForm.get("isResubmission").value,
                clientReferenceNumber: this.detailsForm.get("clientReferenceNumber").value,
                applicationType: this.detailsForm.get(this.applicationTypeFormControlName).value,
                constructionPeriodUnits: this.detailsForm.get(this.constructionPeriodUnitsFormControlName).value,
                services: this.detailsForm.get(this.servicesFormControlName).value,
                licenceNumber: this.detailsForm.get("applicantTelecommunicationLicenseNumber").value,
                scopeOfWork: this.detailsForm.get("scopeOfWork").value,
                estimatedCost: this.detailsForm.get("estimatedConstructionCost").value,
                applicationFee: this.detailsForm.get("applicationFee").value,
                constructionPeriod: this.detailsForm.get(this.constructionPeriodFormControlName).value,
                proposedStartDate: this.detailsForm.get("proposedStartDate").value,
                proposedEndDate: this.detailsForm.get("proposedEndDate").value,
                laneClosureRequired: this.detailsForm.get("laneClosureIsRequired").value,
                laneClosureExtent: this.detailsForm.get("laneClosureExtent").value.value,
                electricalServices: this.detailsForm.get("electricalServices").value.value,
                actualStartDate: this.detailsForm.get("actualStartDate").value,
                actualEndDate: this.detailsForm.get("actualEndDate").value,
                previousReferenceNumber: this.detailsForm.get("previousReferenceNumber").value,
            };
            this.getApplicationSaveObservableSubscription =
                this.viewApplicationService.getApplicationSaveObservable(this.aflaModuleStrategyService.applicationServiceUrl, this.application.id, app)
                    .subscribe({ next: () => {
                        this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                        this.getApplication();
                    }, error: error => {
                        this.appController.handleServerErrorMessage(ViewApplicationDetailsWConstants.STEP_TITLE, error, CRUDOperation.Update);
                    } });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
    }
    getMetadata() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        if (this.aflaModuleStrategyService.lookups.has("laneClosureExtents") &&
            this.aflaModuleStrategyService.lookups.has("applicationType") &&
            this.aflaModuleStrategyService.lookups.has("services") &&
            this.aflaModuleStrategyService.lookups.has("electricalServices")) {
            this.laneClosureExtentOptions = this.aflaModuleStrategyService.lookups.get("laneClosureExtents");
            this.applicationTypeOptions = this.aflaModuleStrategyService.lookups.get("applicationType");
            this.servicesOptions = this.aflaModuleStrategyService.lookups.get("services");
            this.electricalServicesOptions = this.aflaModuleStrategyService.lookups.get("electricalServices");
            this.yesNoOptions = [];
            this.yesNoOptions = Object.values(SharedConstants.YES_NO_ENUM);
            this.changeDetectorRefs.detectChanges();
            this.getApplication();
        }
        else {
            this.getLookups();
        }
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.moduleID} and (name eq 'LaneClosureExtent' or name eq 'ElectricalServices' or name eq 'ApplicationType' or name eq 'Services')`
        };
        this.viewApplicationService
            .getLookupsObservable(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsWConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const laneClosureExtents = [];
        const electricalServices = [];
        const services = [];
        const applicationType = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "LaneClosureExtent") {
                    laneClosureExtents.push(JSON.parse(item.content));
                }
                if (item.name === "ElectricalServices") {
                    electricalServices.push(JSON.parse(item.content));
                }
                if (item.name === "Services") {
                    services.push(JSON.parse(item.content));
                }
                if (item.name === "ApplicationType") {
                    applicationType.push(JSON.parse(item.content));
                }
            });
        }
        laneClosureExtents.sort((a, b) => a.value.localeCompare(b.value));
        electricalServices.sort((a, b) => a.value.localeCompare(b.value));
        applicationType.sort((a, b) => a.value.localeCompare(b.value));
        services.sort((a, b) => a.value.localeCompare(b.value));
        this.yesNoOptions = [];
        this.yesNoOptions = Object.values(SharedConstants.YES_NO_ENUM);
        this.aflaModuleStrategyService.lookups.set("laneClosureExtents", laneClosureExtents);
        this.laneClosureExtentOptions = laneClosureExtents;
        this.aflaModuleStrategyService.lookups.set("electricalServices", electricalServices);
        this.electricalServicesOptions = electricalServices;
        this.aflaModuleStrategyService.lookups.set("services", services);
        this.servicesOptions = services;
        this.aflaModuleStrategyService.lookups.set("applicationType", applicationType);
        this.applicationTypeOptions = applicationType;
        this.getApplication();
        this.changeDetectorRefs.detectChanges();
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.application = response.value[0];
            this.detailsForm.get("description").setValue(this.application.description);
            this.detailsForm.get("referenceNumber").setValue(this.application.referenceNumber);
            this.detailsForm.get("clientReferenceNumber").setValue(this.application.clientReferenceNumber);
            this.detailsForm.get("applicantTelecommunicationLicenseNumber").setValue(this.application.licenceNumber);
            this.detailsForm.get("scopeOfWork").setValue(this.application.scopeOfWork);
            this.detailsForm.get("estimatedConstructionCost").setValue(this.application.estimatedCost);
            this.detailsForm.get("applicationFee").setValue(this.application.applicationFee);
            this.detailsForm.get(this.constructionPeriodFormControlName).setValue(this.application.constructionPeriod);
            this.detailsForm.get("proposedStartDate").setValue(this.datePipe.transform(this.application.proposedStartDate, "yyyy-MM-dd"));
            this.detailsForm.get("proposedEndDate").setValue(this.datePipe.transform(this.application.proposedEndDate, "yyyy-MM-dd"));
            // this.detailsForm.get("laneClosureIsRequired").setValue(this.application.laneClosureRequired);
            this.detailsForm.get("isResubmission").setValue(this.application.isResubmission);
            this.detailsForm.get("previousReferenceNumber").setValue(this.application.previousReferenceNumber);
            this.laneClosureExtentOptions.forEach(item => {
                if (item.value === this.application.laneClosureExtent) {
                    this.detailsForm.get("laneClosureExtent").setValue(item.value);
                }
            });
            this.electricalServicesOptions.forEach(item => {
                if (item.value === this.application.electricalServices) {
                    this.detailsForm.get("electricalServices").setValue(item.value);
                }
            });
            this.laneClosureExtentOptions.forEach(item => {
                if (item.value === this.application.laneClosureExtent) {
                    this.detailsForm.get(this.laneClosureExtentFormControlName).setValue(item.value);
                }
            });
            this.yesNoOptions.forEach(item => {
                if (item === this.application.laneClosureRequired) {
                    this.detailsForm.get(this.laneClosureIsRequiredFormControlName).setValue(item);
                }
            });
            this.constructionPeriodUnitsOptions.forEach(item => {
                if (item.value === this.application.constructionPeriodUnits) {
                    this.detailsForm.get(this.constructionPeriodUnitsFormControlName).setValue(item.value);
                }
            });
            this.servicesOptions.forEach(item => {
                if (item.value === this.application.services) {
                    this.detailsForm.get(this.servicesFormControlName).setValue(item.value);
                }
            });
            this.applicationTypeOptions.forEach(item => {
                if (item.value === this.application.applicationType) {
                    this.detailsForm.get(this.applicationTypeFormControlName).setValue(item.value);
                }
            });
            this.detailsForm.get("actualStartDate").setValue(this.datePipe.transform(this.application.actualStartDate, "yyyy-MM-dd"));
            this.detailsForm.get("actualEndDate").setValue(this.datePipe.transform(this.application.actualEndDate, "yyyy-MM-dd"));
            this.detailsForm.get("description").disable();
            this.detailsForm.get("referenceNumber").disable();
            this.detailsForm.get("isResubmission").disable();
            this.detailsForm.get("previousReferenceNumber").disable();
        }
    }
    verifyProposedDates(formControlName) {
        // checks if the startDate is >= endDate
        CompareDatesUtil.verifyProposedDates(this.detailsForm, this.proposedStartDateFormControlName, this.proposedEndDateFormControlName, formControlName, this.appController);
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: ViewApplicationService },
        { type: AppControllerService },
        { type: DatePipe },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationDetailsWComponent = __decorate([
    Component({
        selector: "app-view-application-details-w",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsWComponent);
export { ViewApplicationDetailsWComponent };
